import { render } from "./QuicksightAccessManagement.vue?vue&type=template&id=2b0b0d64&ts=true"
import script from "./QuicksightAccessManagement.vue?vue&type=script&lang=ts"
export * from "./QuicksightAccessManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__